import {
  Box,
  Button,
  Flex,
  Heading,
  Link,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
} from '@chakra-ui/core';
import moment from 'moment';
import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { ELECTION_RESOLUTION_DATE } from '../utils/Election';
import { toBTC } from '../utils/Utils';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './Table/Table';

const TableEmptyState = ({ label }) => (
  <Flex alignItems="center" justifyContent="center" bg="#F6F6F6" h="200px">
    <Heading fontWeight={500} size="md" color="#7c7c7c">
      {label}
    </Heading>
  </Flex>
);

const AllOffersTable = ({ bets }) => {
  const history = useHistory();
  const BetRow = ({ bet }) => {
    const {
      contractId,
      betDetails: {
        prediction,
        betAmountCounter,
        resolutionDate,
        betSize,
        betAmount,
      },
      twitterInfo,
    } = bet;

    return (
      <TableRow bg="white">
        <TableCell>
          <Flex
            width="fit-content"
            alignItems="center"
            cursor="pointer"
            onClick={() => history.push(`/offers/${twitterInfo.screen_name}`)}
          >
            <Tooltip label={`@${twitterInfo.screen_name}`} hasArrow>
              <Box
                mr={4}
                borderRadius={100}
                boxSize="30px"
                bg="#EBEBEB"
                flexShrink={0}
                background={`url(${twitterInfo.profile_image_url_https.replace(
                  'normal',
                  '200x200'
                )})`}
                backgroundSize="cover"
              ></Box>
            </Tooltip>
            <Box
              h="20px"
              // w="125px"
              maxW="200px"
              fontSize="sm"
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
            >
              {twitterInfo.name}
            </Box>
          </Flex>
        </TableCell>
        <TableCell>
          <Text fontSize="sm">Presidential Election</Text>
        </TableCell>
        <TableCell>
          <Text fontSize="sm" textTransform="capitalize">
            {prediction}
          </Text>
        </TableCell>
        <TableCell>
          <Text fontSize="sm">{toBTC(betAmount)} BTC</Text>
        </TableCell>
        <TableCell>
          <Text fontSize="sm">
            1 : {parseFloat((betAmountCounter / betAmount).toFixed(1))}
          </Text>
        </TableCell>
        <TableCell>
          <Text fontSize="sm">{toBTC(betSize)} BTC</Text>
        </TableCell>
        <TableCell>
          <Text fontSize="sm">
            {moment(
              new Date(resolutionDate).toISOString() ===
                ELECTION_RESOLUTION_DATE.toISOString()
                ? new Date('2020-11-04T02:00:00.000Z')
                : resolutionDate
            ).fromNow()}
          </Text>
        </TableCell>

        <TableCell>
          <Link
            as={RouterLink}
            fontSize="sm"
            color="blue.600"
            fontWeight="bold"
            to={`/offer/${contractId}`}
          >
            View Offer
          </Link>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Box
      bg="white"
      h="fit-content"
      w="100%"
      borderRadius="4px"
      gridArea="bets"
      p={4}
    >
      <Tabs size="sm" isLazy variant="unstyled">
        <TabList mb={4}>
          <Tab
            borderTop="solid 1px #32325d"
            borderBottom="solid 1px #32325d"
            borderRadius="4px"
            _selected={{ bg: '#32325d', color: 'white' }}
          >
            Total Active Bet Offers ({bets.length})
          </Tab>

          <Box ml="auto">
            <RouterLink to="/new">
              <Button size="sm" colorScheme="blue">
                Don't like the odds? Create your own bet
              </Button>
            </RouterLink>
          </Box>
        </TabList>

        {bets.length === 0 ? (
          <TableEmptyState label="No Available Offers" />
        ) : (
          <TabPanels>
            <TabPanel padding={0}>
              <Box display="flex" overflow="auto">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeader></TableHeader>
                      <TableHeader>Bet Type</TableHeader>
                      <TableHeader>Their Prediction</TableHeader>
                      <TableHeader>Their Bet Amount</TableHeader>
                      <TableHeader>Bet Odds</TableHeader>
                      <TableHeader>Total Payout</TableHeader>
                      <TableHeader>Offer Expires</TableHeader>
                      <TableHeader />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {bets.map((bet) => (
                      <BetRow bet={bet} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </TabPanel>
          </TabPanels>
        )}
      </Tabs>
    </Box>
  );
};

export default AllOffersTable;
